import * as Types from 'src/actions/authentication/password-recovery/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import Token from 'src/value-objects/Token';
import { AxiosResponse } from 'axios';
import Authentication from 'src/value-objects/Authentication';
import ValidatorService from 'src/services/validation/Validation.service';

export interface PasswordRecoveryClearErrors extends Action {
  type: Types.PASSWORD_RECOVERY_CLEAR_ERRORS;
}

export const passwordRecoveryClearErrors: ActionCreator<PasswordRecoveryClearErrors> = () => (
  { type: Types.PASSWORD_RECOVERY_CLEAR_ERRORS }
);

export interface PasswordRecoveryAttempt extends Action {
  type: Types.PASSWORD_RECOVERY_ATTEMPT;
}

export interface PasswordRecoverySuccess extends Action {
  type: Types.PASSWORD_RECOVERY_SUCCESS;
  payload: Token;
}

export interface PasswordRecoveryFailure extends Action {
  type: Types.PASSWORD_RECOVERY_FAILURE;
  payload: {};
}

export type PasswordRecoveryAction = PasswordRecoveryAttempt |
  PasswordRecoverySuccess |
  PasswordRecoveryFailure |
  PasswordRecoveryClearErrors;

export interface PasswordRecoveryThunk extends ThunkAction<Promise<PasswordRecoveryAction>, RootState, null> {
}

export const passwordRecoveryAttempt: ActionCreator<PasswordRecoveryAttempt> = () => (
  { type: Types.PASSWORD_RECOVERY_ATTEMPT }
);

export const passwordRecoverySuccess: ActionCreator<PasswordRecoverySuccess> = (token: Token) => (
  {
    type: Types.PASSWORD_RECOVERY_SUCCESS,
    payload: token
  }
);

export const passwordRecoveryFailure: ActionCreator<PasswordRecoveryFailure> = (error: {}) => (
  {
    type: Types.PASSWORD_RECOVERY_FAILURE,
    payload: error

  }
);

export const passwordRecovery: ActionCreator<PasswordRecoveryThunk> = (
  credentials: Authentication
): PasswordRecoveryThunk => {

  return (dispatch: Dispatch<RootState>): Promise<PasswordRecoveryAction> => {
    dispatch(passwordRecoveryAttempt());

    return ApiClient.passwordRecovery.create(credentials)
      .then((response: AxiosResponse<{}>): PasswordRecoverySuccess => {

        return dispatch(passwordRecoverySuccess());
      }).catch((response: AxiosResponse<{}>): PasswordRecoveryFailure => {
        const errors = ValidatorService.translateValidations(JSON.parse(response.request.response).error);
        return dispatch(passwordRecoveryFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/authentication/password-recovery/PasswordRecovery.actions.tsx